import React, { useEffect, useState } from "react";
import { Row, Badge, Popover } from "antd";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";
import { ReactComponent as Logo } from "../../assets/icons/logo.svg";
import { ReactComponent as Bell } from "../../assets/icons/bell.svg";
import NotificationComponent from "./Notification/NotificationComponent";
import { ReactComponent as Help } from "../../assets/icons/help.svg";
import CityDropdown from "./CityDropdown";
import {
  CenterContainer,
  HeaderContainer,
  HelpIconWrapper,
  LeftContainer,
  OpenCloseButton,
  ProfileContainer,
  RightContainer,
  ViewText,
} from "./NavbarStyled";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { sellerRoutes } from "../Sidebar/menuItems";
import { useDispatch, useSelector } from "react-redux";
import { sellerViewStatusSelector } from "../../redux/slices/sellerCatalogue/selector";
import { getViewStatus } from "../../redux/slices/sellerCatalogue/action";
import { loginUserDetailSelector } from "../../redux/slices/loginAuth/selector";
import { setSelectedCity } from "../../redux/slices/loginAuth/action";
import ProfileDropdown from "./ProfileDropDown/ProfileDropdown";
import { MainSearchInput } from "../MainSearchInput/MainSearchInput";
import { useLazyGetNotificationQuery } from "../../apis/dashboard";

const Navbar = ({ setCollapsed, collapsed }) => {
  const { pathname } = useLocation();
  const param = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [getNotifications, { data: notificationData, isLoading }] =
    useLazyGetNotificationQuery();
  const [visible, setVisible] = useState(false);
  const [notificationCount, setNotificationCount] = useState(() =>
    parseInt(localStorage.getItem("notification_count") || "0", 10)
  );

  useEffect(() => {
    const count = localStorage.getItem("notification_count");
    if (count) {
      setNotificationCount(parseInt(count, 10));
    }
  }, []);
useEffect(() => {
  const handleNotificationCountUpdate = () => {
    const count = localStorage.getItem('notification_count');
    setNotificationCount(parseInt(count || '0', 10));
  };
  window.addEventListener('notification_count_updated', handleNotificationCountUpdate);
  return () => window.removeEventListener('notification_count_updated', handleNotificationCountUpdate);
}, []);

  const handleNotificationClick = () => {
    if (!visible) {
      getNotifications();
    }
    setVisible(!visible);
  };
  const sellerStatus = useSelector(sellerViewStatusSelector);
  const loginUserDetail = useSelector(loginUserDetailSelector);
  const url_parts = pathname.split("/");
  const new_url = url_parts.slice(0, url_parts.length - 1).join("/");
  const seller_route_check = sellerRoutes.includes(new_url);

  const cityAccessList =
    loginUserDetail?.profile_details?.allowed_cities ||
    JSON.parse(localStorage.getItem("cityAccess") || "[]");
  const cityOptions = cityAccessList.map((city) => ({
    label: city,
    value: city,
  }));
  const [selectedCity, setSelectedCityState] = useState(
    () => localStorage.getItem("selectedCity") || ""
  );

  useEffect(() => {
    if (!selectedCity && cityOptions.length) {
      const firstCity = cityOptions[0].value;
      setSelectedCityState(firstCity);
      localStorage.setItem("selectedCity", firstCity);
      dispatch(setSelectedCity(firstCity));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityAccessList.length]);

  const handleCityChange = (value) => {
    localStorage.setItem("selectedCity", value);
    dispatch(setSelectedCity(value));
    window.location.reload();
  };

  const handleNavigate = () => {
    if (seller_route_check) {
      navigate(`/admin/sellers/seller-view/${sellerStatus?.bmp_id}`);
    }
    dispatch(getViewStatus({}));
  };
  const handleNavigateDashboard = () => {
    const currentPath = window.location.pathname;
    const dashboardPath = "/admin/dashboard";
    if (currentPath === dashboardPath) {
      window.location.reload();
    } else {
      navigate(dashboardPath);
    }
  };

  return (
    <HeaderContainer
      style={{
        backgroundColor: seller_route_check ? "#42919b" : "#0354a3",
      }}
    >
      <Row>
        <LeftContainer xs={16} md={8}>
          <OpenCloseButton onClick={() => setCollapsed(!collapsed)}>
            {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </OpenCloseButton>

          <Logo
            style={{ cursor: "pointer" }}
            onClick={handleNavigateDashboard}
          />
          {seller_route_check ? (
            <ViewText style={{ cursor: "pointer" }} onClick={handleNavigate}>
              {`${sellerStatus?.bmp_id || param?.seller_id}
                 ${
                   sellerStatus?.vendor_name
                     ? `(${sellerStatus?.vendor_name})`
                     : ""
                 }`}
            </ViewText>
          ) : (
            <CityDropdown
              value={selectedCity}
              placeholder="Select city"
              options={cityOptions}
              onChange={handleCityChange}
            />
          )}
        </LeftContainer>
        <CenterContainer xs={0} md={8}>
          <MainSearchInput />
        </CenterContainer>
        <RightContainer xs={8} md={8}>
          <Popover
            content={
              <NotificationComponent
                notifications={notificationData?.data || []}
                isLoading={isLoading}
              />
            }
            trigger="click"
            placement="bottomRight"
            overlayClassName="notification-popover"
            open={visible}
            onOpenChange={handleNotificationClick}
          >
            <Badge
              count={notificationCount || notificationData?.count || 0}
              offset={[0, 0]}
            >
              <Bell style={{ cursor: "pointer" }} />
            </Badge>
          </Popover>
          <HelpIconWrapper>
            <Help />
          </HelpIconWrapper>
          <ProfileContainer>
            <ProfileDropdown />
          </ProfileContainer>
        </RightContainer>
      </Row>
    </HeaderContainer>
  );
};

export default Navbar;
